import React, { useEffect, useState } from "react";
import styled from "styled-components";
//eslint-disable-next-line
import { FiPhoneCall } from "react-icons/fi";
import GaugeChart from "react-gauge-chart";
//eslint-disable-next-line
import { IoMdMail } from "react-icons/io";
import { AiOutlineArrowLeft, AiOutlineDown } from "react-icons/ai";
//eslint-disable-next-line
import { notification } from "assets/icons";
import TransactionPerformance from "chartPages/TransactionPerformance";
import { VscCircleFilled } from "react-icons/vsc";
//import DashboardLayout from "layouts/DashboardLayout";
import TodayTransactionsChart from "chartPages/TodayTransactionsChart";
import moment from "moment";
import { kFormatter2, kFormatter3, kFormatter4 } from "utils/format";
import TotalTransactionChart from "chartPages/TotalTransactionChart";
import { FormInput } from "components";
import RadioFilter from "./RadioInstitutionFilter";
import CheckedFilter from "./CheckedInstitutionFilter";
import { userData } from "utils/userData";
import { Router } from "utils/route";
import { toast } from "react-hot-toast";
import { handleCheckMetric } from "utils/handleMetricsChekc";
import Skeleton2 from "./Skeleton2";
import { ApiService } from "services";
import { useInstitutionDetails } from "hooks/useInstitutionDetails";

function InstitutionDetails({
  close,
  showTransactions,
  id,
  code,
}) {
  const [boundType, setBoundType] = useState("inbound");
  const [seconds, setSeconds] = useState(300);
  const [secondsOpen, setSecondsOpen] = useState(false);
  const [showResponseTimeBanks, setShowResponseTimeBanks] = useState(false);
  const [showBanks, setShowBanks] = useState(false);
  const [updateSeconds, setUpdateSeconds] = useState(300);
  const [checked, setChecked] = useState("");
  const [checked2, setChecked2] = useState("All");
  const [selectedItems, setSelectedItems] = useState([]);

  const { data, loading, refetch } = useInstitutionDetails(id, boundType, seconds, selectedItems, checked);
  const { route } = Router();


  const dashboardData = data?.indicator?.data?.[0] || {};
  const dashboardData4 = data?.approvalRate?.data?.[0] || {};
  const dashboardData5 = data?.adminUsers?.data?.[0] || {};
  const dashboardData6 = data?.adminUsers?.data?.[0] || {}; // Mapping adminUsers to both 5 and 6 as they share the source
  const dashboardData7 = data?.recentBanks?.data?.[0] || {};
  const dashboardData8 = data?.adminUsers?.data?.[0] || {}; // unused but mapped for safety
  const dashboardData9 = data?.transactionPerformance?.data?.[0] || {};
  const dashboardData10 = data?.transaction?.data?.[0] || {};

  // Removed old props destructuring


  const transactions = dashboardData?.recentTransactions;

  const totaltTransactions = dashboardData10?.transaction;
  console.log(dashboardData7, "dets");

  //const [boundType2, setBoundType2] = useState("Inbound");

  const [balanceEnquiry, setBalanceEnquiry] = useState();
  const [balanceConfig, setBalanceConfig] = useState();

  const [loadingEnquiry, setLoadingEnquiry] = useState(false);
  const [loadingConfig, setLoadingConfig] = useState(false);
  const [loadingBalance, setLoadingBalance] = useState(false);
  const [balanceConfigModal, setBalanceConfigModal] = useState(false);
  const [editingConfigIndex, setEditingConfigIndex] = useState(null);
  const [balanceConfigData, setBalanceConfigData] = useState({
    accountNumber: "",
    balanceApiEnabled: true,
    balanceApiUrl: "",
  });

  const getBalanceEnquiry = async (id) => {
    setLoadingEnquiry(true);

    try {
      const data = await ApiService.getBalanceEnquiry(id);
      setLoadingEnquiry(false);
      setBalanceEnquiry(data?.data);
      console.log(data?.data);
    } catch (err) {
      console.log(err);
      setLoadingEnquiry(false);
      if (err?.message === "It's not you, it's us. Try again later.") {
      } else if (err?.message === "Network Error") {
        return;
      } else {
        toast.error(err?.response?.data?.message || err?.message);
      }
    }
  };

  const getBalanceConfig = async (id) => {
    setLoadingConfig(true);

    try {
      const data = await ApiService.getBalanceConfig(id);
      setLoadingConfig(false);
      setBalanceConfig(data?.data);
      console.log(data?.data);
    } catch (err) {
      console.log(err);
      setLoadingConfig(false);
      if (err?.message === "It's not you, it's us. Try again later.") {
      } else if (err?.message === "Network Error") {
        return;
      } else {
        toast.error(err?.response?.data?.message || err?.message);
      }
    }
  };

  useEffect(() => {
    getBalanceEnquiry(code);
    getBalanceConfig(id);
  }, []);

  const options2 = {
    series: [
      {
        name: "Success",
        data: dashboardData9?.transactionPerformance?.report?.map(
          (item) => item?.success
        ) || ["0"],
        color: "#01A926",
      },
      {
        name: "Pending",
        data: dashboardData9?.transactionPerformance?.report?.map(
          (item) => item?.pending
        ) || ["0"],
        color: "#FF993A",
      },
      {
        name: "Failed",
        data: dashboardData9?.transactionPerformance?.report?.map(
          (item) => item?.failed
        ) || ["0"],
        color: "#FF2E00",
      },
    ],
    options: {
      tooltip: {
        enabled: true,
        enabledOnSeries: undefined,
        shared: true,
        followCursor: false,
        intersect: false,
        style: {
          fontSize: "12px",
          fontFamily: undefined,
        },
        onDatasetHover: {
          highlightDataSeries: false,
        },
        x: {
          show: true,
        },
        y: {
          formatter: function (val) {
            return Math.abs(val) > 999999999
              ? ` ${Math.sign(val) * (Math.abs(val) / 1000000000).toFixed(1)}B`
              : Math.abs(val) > 999999
                ? `${Math.sign(val) * (Math.abs(val) / 1000000).toFixed(1)}M`
                : Math.abs(val) > 999
                  ? `${Math.sign(val) * (Math.abs(val) / 1000).toFixed(1)}k`
                  : Math.sign(val) * Math.abs(val);
          },
          title: {
            formatter: (seriesName) => seriesName,
          },
        },
        z: {
          formatter: function (val) {
            return Math.abs(val) > 999999999
              ? ` ${Math.sign(val) * (Math.abs(val) / 1000000000).toFixed(1)}B`
              : Math.abs(val) > 999999
                ? `${Math.sign(val) * (Math.abs(val) / 1000000).toFixed(1)}M`
                : Math.abs(val) > 999
                  ? `${Math.sign(val) * (Math.abs(val) / 1000).toFixed(1)}k`
                  : Math.sign(val) * Math.abs(val);
          },
          title: "Size: ",
        },
        marker: {
          show: true,
        },
        items: {
          display: "flex",
        },
        fixed: {
          enabled: false,
          position: "topRight",
          offsetX: 0,
          offsetY: 0,
        },
      },
      chart: {
        type: "bar",
        stacked: true,
        toolbar: {
          show: false,
        },
        zoom: {
          enabled: true,
        },
      },
      responsive: [
        {
          breakpoint: 480,
          options: {
            legend: {
              position: "bottom",
              offsetX: -10,
              offsetY: 0,
            },
          },
        },
      ],
      plotOptions: {
        bar: {
          horizontal: false,
          borderRadius: 0,
          columnWidth: "36%",
          dataLabels: {
            total: {
              enabled: false,
              style: {
                fontSize: "0px",
                fontWeight: 10,
              },
            },
          },
        },
      },
      xaxis: {
        categories:
          dashboardData9?.transactionPerformance?.report?.map(
            (item) => item?.day
          ) || [],
      },
      yaxis: {
        labels: {
          formatter: function (val) {
            return Math.abs(val) > 999999999
              ? ` ${Math.sign(val) * (Math.abs(val) / 1000000000).toFixed(1)}B`
              : Math.abs(val) > 999999
                ? `${Math.sign(val) * (Math.abs(val) / 1000000).toFixed(1)}M`
                : Math.abs(val) > 999
                  ? `${Math.sign(val) * (Math.abs(val) / 1000).toFixed(1)}k`
                  : Math.sign(val) * Math.abs(val);
          },
        },
      },
      legend: {
        show: false,
      },
      fill: {
        opacity: 1,
      },
      dataLabels: {
        enabled: false,
      },
    },
  };
  const options3 = {
    series: [
      dashboardData6?.institutionData?.totalSuccessTransactionCount,
      dashboardData6?.institutionData?.totalFailedTransactionCount,
      dashboardData6?.institutionData?.totalPendingTransactionCount,
    ],
    options: {
      labels: [
        `<span>Successful <br/> ${kFormatter3(
          dashboardData6?.institutionData?.totalSuccessTransactionAmount
        )} <br/> ${kFormatter2(
          dashboardData6?.institutionData?.totalSuccessTransactionCount
        )}</span> `,
        `<span>Failed <br/> ${kFormatter3(
          dashboardData6?.institutionData?.totalFailedTransactionAmount
        )}<br/> ${kFormatter2(
          dashboardData6?.institutionData?.totalFailedTransactionCount
        )} </span>  `,
        `<span>Pending <br/> ${kFormatter3(
          dashboardData6?.institutionData?.totalPendingTransactionAmount
        )}<br/> ${kFormatter2(
          dashboardData6?.institutionData?.totalPendingTransactionCount
        )}</span> `,
      ],
      tooltip: {
        enabled: true,
        enabledOnSeries: undefined,
        shared: true,
        followCursor: false,
        intersect: false,
        style: {
          fontSize: "12px",
          fontFamily: undefined,
        },
        onDatasetHover: {
          highlightDataSeries: false,
        },
        x: {
          show: true,
        },
        y: {
          formatter: function (val) {
            return val - val === 0 ? "" : "";
          },
          title: {
            formatter: (seriesName) => seriesName,
          },
        },

        marker: {
          show: true,
        },
        items: {
          display: "flex",
        },
        fixed: {
          enabled: false,
          position: "topRight",
          offsetX: 0,
          offsetY: 0,
        },
      },
      chart: {
        type: "donut",
      },
      colors: ["#01A926", "#FE0004", "#F9C74F"],

      dataLabels: {
        enabled: false,
      },

      legend: {
        position: "right",
        offsetY: 0,
        height: 150,
        show: false,
      },
    },
  };

  const banks = dashboardData7?.recentBanks || [];



  function formatTime(seconds) {
    return [
      seconds / 60 / 60 / 24 >= 1
        ? `${parseInt(seconds / 60 / 60 / 24)}d `
        : "",
      seconds / 60 / 60 < 24
        ? seconds / 60 / 60 !== 0
          ? `${parseInt(seconds / 60 / 60)}h `
          : ""
        : "",
      (seconds / 60) % 60 !== 0 ? `${parseInt((seconds / 60) % 60)}m ` : "",
      seconds % 60 !== 0 ? `${parseInt(seconds % 60)}s` : "",
    ]
      .join("")
      .replace(/\b(\d)\b/g, "0$1");
  }

  console.log(checked, "mee");

  const configureBalance = async (data) => {
    setLoadingBalance(true);
    try {
      const response = await ApiService.createBalanceConfiguration(data);
      setLoadingBalance(false);
      console.log(response);
      toast.success("Balance configuration updated successfully!");
      setBalanceConfigModal(false);
      setEditingConfigIndex(null);
      getBalanceEnquiry(code);
      getBalanceConfig(id);
    } catch (err) {
      console.log(err);

      setLoadingBalance(false);
      if (err?.message === "It's not you, it's us. Try again later.") {
      } else if (err?.message === "Network Error") {
        return;
      } else {
        toast.error(err?.response?.data?.message || err?.message);
      }
    }
  };

  const handleBalanceConfigSubmit = () => {
    if (!balanceConfigData.accountNumber || !balanceConfigData.balanceApiUrl) {
      toast.error("Please fill in all required fields");
      return;
    }

    // If editing a specific configuration from an array, include the index
    const configData =
      editingConfigIndex !== null
        ? { ...balanceConfigData, configIndex: editingConfigIndex }
        : balanceConfigData;

    configureBalance(configData);
  };



  // Removed manual effects for callBound and initial callMain6


  return (
    <Bg
      onClick={() => {
        setShowResponseTimeBanks(false);
        setShowBanks(false);
      }}
    >
      {/* <Container>
        <div className="msg">
          <p>
            {" "}
            <FiPhoneCall size={22} color={color} /> +234 8132 265445
          </p>
          <p>
            {" "}
            <IoMdMail size={22} color={color} /> Contact@firstbanknigeria.ng
          </p>
        </div>

        <img src={notification} className="notification" alt="" />
      </Container> */}
      {userData?.userDetail?.role === "chiefAdmin" && (
        <p onClick={() => close(false)}>
          <AiOutlineArrowLeft size={20} /> Back
        </p>
      )}

      {userData?.userDetail?.role === "subAdmin1" && (
        <p onClick={() => close(false)}>
          <AiOutlineArrowLeft size={20} /> Back
        </p>
      )}

      {userData?.userDetail?.role === "subAdmin2" && (
        <p onClick={() => close(false)}>
          <AiOutlineArrowLeft size={20} /> Back
        </p>
      )}

      <>
        <div
          style={{
            display: "flex",
            alignItems: "flex-start",
            justifyContent: "space-between",
            marginTop: "30px",
            marginBottom: "20px",
          }}
        >
          <div className="">
            <div className="btn">
              <button
                onClick={() => {
                  setBoundType("inbound");
                  //callBound();
                  setSelectedItems([]);
                  setChecked2("All");
                }}
                style={{
                  backgroundColor: boundType === "inbound" && "#14A2FD",
                  color: boundType !== "inbound" ? "gray" : "white",
                  border: boundType !== "inbound" && "1px solid gainsboro",
                  cursor: "pointer",
                }}
              >
                Inbound
              </button>
              <button
                onClick={() => {
                  setBoundType("outbound");
                  // callBound();
                }}
                style={{
                  backgroundColor: boundType === "outbound" && "#14A2FD",
                  border: boundType !== "outbound" && "1px solid gainsboro",
                  color: boundType !== "outbound" ? "gray" : "white",
                  cursor: "pointer",
                }}
              >
                Outbound
              </button>
            </div>
            <div className="institution">
              <h2>{dashboardData?.name}</h2>
              <p>Today, {formatTime(updateSeconds)} ago</p>
            </div>
          </div>
          {boundType === "outbound" && (
            <div className="header">
              <div className="time">
                <span
                  onClick={() => {
                    setSecondsOpen(!secondsOpen);
                  }}
                  style={{
                    position: "relative",
                    cursor: "pointer",
                    marginBottom: "20px",
                  }}
                >
                  Filter By Last {seconds} Seconds <AiOutlineDown />
                  {secondsOpen && (
                    <DropDown
                      onClick={(e) => {
                        e.stopPropagation();
                      }}
                      style={{ cursor: "default", width: "300px" }}
                    >
                      <div className="title" style={{ padding: "20px 0" }}>
                        Fetch Time Frame
                      </div>

                      <form
                        onSubmit={(e) => {
                          e.preventDefault();
                          if (seconds >= 300) {
                            setSecondsOpen(false);
                            setUpdateSeconds(seconds);
                          } else {
                            toast.error("Must not be less than 15 seconds");
                          }
                        }}
                      >
                        <FormInput
                          onChange={(e) => {
                            setSeconds(e.target.value);
                          }}
                          type="number"
                          background="#F2F7FF"
                          padding="10px 14px"
                          placeholder="Enter Seconds"
                        />
                      </form>

                      <svg
                        style={{
                          position: "absolute",
                          top: "50%",
                          right: "30px",
                          transform: "translateY(100%)",
                          cursor: "pointer",
                        }}
                        onClick={() => {
                          if (seconds >= 300) {
                            setSecondsOpen(false);
                            setUpdateSeconds(seconds);
                          } else {
                            toast.error("Must not be less than 15 seconds");
                          }
                        }}
                        //&indicatorBanks=214,800&outboundBank=214

                        width="20"
                        height="20"
                        viewBox="0 0 20 20"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <g clip-path="url(#clip0_505_4722)">
                          <path
                            d="M10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20Z"
                            fill="#00B3FE"
                          />
                          <path
                            d="M15.1196 9.12419C13.979 7.98365 12.8387 6.84311 11.6981 5.70258C10.6189 4.62314 8.95014 6.30466 10.0321 7.38663C10.497 7.85149 10.9619 8.31638 11.4267 8.78141C9.59614 8.78141 7.76556 8.78141 5.93516 8.78141C4.40556 8.78141 4.39213 11.1506 5.9181 11.1506C7.7545 11.1506 9.5909 11.1506 11.4272 11.1506C10.9592 11.6186 10.4911 12.0866 10.0231 12.5547C8.94368 13.6339 10.6252 15.3027 11.7072 14.2207C12.8477 13.0803 13.9881 11.94 15.1286 10.7994C15.5865 10.3413 15.574 9.57849 15.1196 9.12419Z"
                            fill="white"
                          />
                        </g>
                        <defs>
                          <clipPath id="clip0_505_4722">
                            <rect width="20" height="20" fill="white" />
                          </clipPath>
                        </defs>
                      </svg>
                    </DropDown>
                  )}
                </span>
              </div>
            </div>
          )}

          {boundType === "inbound" && (
            <div>
              <div className="header">
                <div className="time">
                  <span
                    onClick={() => {
                      setSecondsOpen(!secondsOpen);
                      setSeconds(300);
                    }}
                    style={{
                      position: "relative",
                      cursor: "pointer",
                      marginBottom: "20px",
                    }}
                  >
                    Filter By Last {seconds} Seconds <AiOutlineDown />
                    {secondsOpen && (
                      <DropDown
                        onClick={(e) => {
                          e.stopPropagation();
                        }}
                        style={{ cursor: "default", width: "300px" }}
                      >
                        <div className="title" style={{ padding: "20px 0" }}>
                          Fetch Time Frame
                        </div>

                        <form
                          onSubmit={(e) => {
                            e.preventDefault();
                            if (seconds >= 300) {
                              setSecondsOpen(false);
                              setUpdateSeconds(seconds);
                            } else {
                              toast.error("Must not be less than 15 seconds");
                            }
                          }}
                        >
                          <FormInput
                            onChange={(e) => {
                              setSeconds(e.target.value);
                            }}
                            type="number"
                            background="#F2F7FF"
                            padding="10px 14px"
                            placeholder="Enter Seconds"
                          />
                        </form>
                        <svg
                          style={{
                            position: "absolute",
                            top: "50%",
                            right: "30px",
                            transform: "translateY(100%)",
                            cursor: "pointer",
                          }}
                          onClick={() => {
                            if (seconds >= 300) {
                              setSecondsOpen(false);
                              setUpdateSeconds(seconds);
                            } else {
                              toast.error("Must not be less than 15 seconds");
                            }
                          }}
                          width="20"
                          height="20"
                          viewBox="0 0 20 20"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <g clip-path="url(#clip0_505_4722)">
                            <path
                              d="M10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20Z"
                              fill="#00B3FE"
                            />
                            <path
                              d="M15.1196 9.12419C13.979 7.98365 12.8387 6.84311 11.6981 5.70258C10.6189 4.62314 8.95014 6.30466 10.0321 7.38663C10.497 7.85149 10.9619 8.31638 11.4267 8.78141C9.59614 8.78141 7.76556 8.78141 5.93516 8.78141C4.40556 8.78141 4.39213 11.1506 5.9181 11.1506C7.7545 11.1506 9.5909 11.1506 11.4272 11.1506C10.9592 11.6186 10.4911 12.0866 10.0231 12.5547C8.94368 13.6339 10.6252 15.3027 11.7072 14.2207C12.8477 13.0803 13.9881 11.94 15.1286 10.7994C15.5865 10.3413 15.574 9.57849 15.1196 9.12419Z"
                              fill="white"
                            />
                          </g>
                          <defs>
                            <clipPath id="clip0_505_4722">
                              <rect width="20" height="20" fill="white" />
                            </clipPath>
                          </defs>
                        </svg>
                      </DropDown>
                    )}
                  </span>
                  {handleCheckMetric(
                    "sitePerformance",
                    userData?.userDetail?.metrics
                  ) && (
                      <GaugeStyle>
                        <div className="gauge">
                          <div>
                            <div style={{ margin: "10px 0" }}>Response Time</div>

                            <GaugeChart
                              id="gauge-chart3"
                              nrOfLevels={30}
                              colors={["#37ffa8", "#FFC371", "#EA4228"]}
                              arcWidth={0.3}
                              style={{ width: "100%" }}
                              textColor="#fd9c0a0"
                              hideText={true}
                              percent={
                                (dashboardData?.sitePerformanceIndicator?.[0]
                                  ?.averageSec || 0) > 45
                                  ? 1
                                  : (dashboardData?.sitePerformanceIndicator?.[0]
                                    ?.averageSec || 0) / 45
                              }
                            />
                            <div className="gauge_sec">
                              {
                                dashboardData?.sitePerformanceIndicator?.[0]
                                  ?.averageSec
                              }
                              s
                            </div>
                          </div>
                        </div>

                        <div className="gauge">
                          <div>
                            <div style={{ margin: "10px 0" }}>Approval Rate</div>

                            <GaugeChart
                              id="gauge-chart3"
                              nrOfLevels={30}
                              colors={["#EA4228", "#FFC371", "#37ffa8"]}
                              arcWidth={0.3}
                              style={{ width: "100%" }}
                              textColor="#fd9c0a0"
                              hideText={true}
                              percent={
                                (dashboardData4?.siteApprovalRate?.[0]
                                  ?.approvalRate || 0) / 100
                              }
                            />
                          </div>
                          <div className="gauge_sec">
                            {dashboardData4?.siteApprovalRate?.[0]?.approvalRate}%
                          </div>
                        </div>
                      </GaugeStyle>
                    )}
                </div>
              </div>
            </div>
          )}
        </div>

        {boundType === "outbound" && (
          <div
            style={{
              marginBottom: "10px",
            }}
          >
            <div className="">
              {/*  <span>
              Last 5 Seconds <AiOutlineDown size={13} />
            </span> */}
              {handleCheckMetric(
                "sitePerformance",
                userData?.userDetail?.metrics
              ) && (
                  <div
                    style={{
                      margin: "20px 0",
                      marginBottom: "40px",
                      cursor: "pointer",
                      border: "1px solid #d4d4d4",
                      padding: "10px",
                      borderRadius: "8px",
                      width: "fit-content",
                      position: "relative",
                    }}
                    onClick={(e) => {
                      setShowResponseTimeBanks(!showResponseTimeBanks);
                      setShowBanks(false);
                      e.stopPropagation();
                    }}
                  >
                    Filter Banks
                    <svg
                      style={{ marginLeft: "10px", marginBottom: "2px" }}
                      width="10"
                      height="6"
                      viewBox="0 0 10 6"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M1.25 1.125L5 4.875L8.75 1.125"
                        stroke="#5A6376"
                        stroke-width="1.875"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                    {showResponseTimeBanks && (
                      <CheckedFilter
                        onClick={(e) => {
                          e.stopPropagation();
                        }}
                        banks={banks}
                        loading={loading}
                        selectedItems={selectedItems}
                        setSelectedItems={setSelectedItems}
                        onClick2={() => {
                          setShowResponseTimeBanks(false);
                        }}
                      />
                    )}
                  </div>
                )}
              {handleCheckMetric(
                "sitePerformance",
                userData?.userDetail?.metrics
              ) && (
                  <div>
                    <div
                      style={{
                        margin: "10px 0",
                      }}
                    >
                      Response Time
                    </div>
                    <div
                      style={{
                        color: "#a7a7a7",
                        marginBottom: "40px",
                        fontSize: "16px",
                      }}
                    >
                      {dashboardData?.sitePerformanceIndicator?.length === 0 &&
                        "No Response Time Data"}
                    </div>
                    {loading ? (
                      <Skeleton2 height="100px" />
                    ) : (
                      <GaugeStyle>
                        {dashboardData?.sitePerformanceIndicator?.map((item) => {
                          return (
                            <div className="gauge">
                              <div>
                                <GaugeChart
                                  id="gauge-chart3"
                                  nrOfLevels={30}
                                  colors={["#37ffa8", "#FFC371", "#EA4228"]}
                                  arcWidth={0.3}
                                  style={{ width: "100%" }}
                                  textColor="#fd9c0a0"
                                  hideText={true}
                                  percent={
                                    item?.averageSec > 45
                                      ? 45
                                      : item?.averageSec / 45
                                  }
                                />
                                <div className="gauge_sec">
                                  {item?.averageSec}s
                                </div>
                                <div className="gauge_text">
                                  {item?.institution || "Institution"}
                                </div>
                              </div>
                            </div>
                          );
                        })}
                      </GaugeStyle>
                    )}

                    <div
                      style={{
                        margin: "10px 0",
                      }}
                    >
                      Approval Rate{" "}
                    </div>
                    <div
                      style={{
                        color: "#a7a7a7",
                        marginBottom: "40px",
                        fontSize: "16px",
                      }}
                    >
                      {dashboardData4?.siteApprovalRate?.length === 0 &&
                        "No Approval Rate Data"}
                    </div>
                    {loading ? (
                      <Skeleton2 height="100px" />
                    ) : (
                      <GaugeStyle>
                        {dashboardData4?.siteApprovalRate?.map((item) => {
                          return (
                            <div className="gauge">
                              <div>
                                <GaugeChart
                                  id="gauge-chart3"
                                  nrOfLevels={30}
                                  colors={["#EA4228", "#FFC371", "#37ffa8"]}
                                  arcWidth={0.3}
                                  style={{ width: "100%" }}
                                  textColor="#fd9c0a0"
                                  hideText={true}
                                  percent={item?.approvalRate / 100}
                                />
                                <div className="gauge_sec">
                                  {item?.approvalRate}%
                                </div>
                                <div className="gauge_text">
                                  {item?.institution || "Institution"}
                                </div>
                              </div>
                            </div>
                          );
                        })}
                      </GaugeStyle>
                    )}
                  </div>
                )}
            </div>
          </div>
        )}

        <Chatgrid>
          <Gridtemplate>
            {handleCheckMetric(
              "transactionCountAmount",
              userData?.userDetail?.metrics
            ) &&
              (loading ? (
                <Skeleton2 height="100%" />
              ) : (
                <Terminal style={{ background: "#DFEDF6" }}>
                  <svg
                    style={{ position: "absolute", top: "14px", right: "14px" }}
                    width="58"
                    height="57"
                    viewBox="0 0 58 57"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <rect
                      x="5"
                      y="4.5"
                      width="48"
                      height="48"
                      rx="24"
                      fill="#4945C4"
                    />
                    <path
                      d="M29.5323 18.7538C24.0182 18.6021 19.5007 23.0329 19.5007 28.5038H18.7965C18.309 28.5038 17.8756 28.5038 18.4173 29.4246L20.2048 32.4579C20.4215 32.6746 20.7573 32.6746 20.974 32.4579L22.599 29.4246C22.6738 29.3482 22.7244 29.2514 22.7443 29.1464C22.7643 29.0413 22.7526 28.9327 22.7109 28.8342C22.6692 28.7357 22.5993 28.6518 22.51 28.593C22.4207 28.5342 22.3159 28.5032 22.209 28.5038H21.6673C21.6673 24.2788 25.1123 20.8663 29.359 20.9204C33.389 20.9746 36.7798 24.3654 36.834 28.3954C36.8882 32.6313 33.4757 36.0871 29.2507 36.0871C27.5065 36.0871 25.8923 35.4913 24.614 34.4838C24.4065 34.3203 24.1462 34.2388 23.8825 34.2548C23.6188 34.2708 23.3702 34.3831 23.184 34.5704C22.729 35.0254 22.7615 35.7946 23.2707 36.1846C24.9727 37.5306 27.0807 38.26 29.2507 38.2538C34.7215 38.2538 39.1523 33.7363 39.0007 28.2221C38.8598 23.1413 34.6132 18.8946 29.5323 18.7538ZM28.9798 24.1704C28.5357 24.1704 28.1673 24.5388 28.1673 24.9829V28.9696C28.1673 29.3488 28.3732 29.7063 28.6982 29.9013L32.0782 31.9054C32.4682 32.1329 32.9665 32.0029 33.194 31.6238C33.4215 31.2338 33.2915 30.7354 32.9123 30.5079L29.7923 28.6554V24.9721C29.7923 24.5388 29.424 24.1704 28.9798 24.1704Z"
                      fill="white"
                    />
                    <rect
                      x="5"
                      y="4.5"
                      width="48"
                      height="48"
                      rx="24"
                      stroke="#4945C4"
                      stroke-opacity="0.1"
                      stroke-width="9"
                    />
                  </svg>

                  <div>
                    <div style={{ color: "#909090" }}>
                      Total Transaction Count
                    </div>
                    <div style={{ fontSize: "28px", marginTop: "10px" }}>
                      {kFormatter2(
                        dashboardData6?.institutionData
                          ?.totalTransactionCount || 0
                      )}
                    </div>
                  </div>
                  <div
                    style={{
                      marginTop: "24px",
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "flex-start",
                      alignItems: "flex-start",
                    }}
                  >
                    <div
                      style={{
                        textAlign: "left",
                        marginBottom: "12px",
                      }}
                    >
                      <div
                        style={{
                          textAlign: "left",
                          color: "#909090",
                          marginBottom: "8px",
                          fontSize: "13px",
                        }}
                      >
                        <svg
                          style={{
                            marginRight: "8px",
                          }}
                          width="9"
                          height="10"
                          viewBox="0 0 9 10"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <circle cx="4.5" cy="5" r="4.5" fill="#01A926" />
                        </svg>
                        Successful
                      </div>
                      <div style={{ textAlign: "left" }}>
                        {kFormatter2(
                          dashboardData6?.institutionData
                            ?.totalSuccessTransactionCount || 0
                        )}
                      </div>
                    </div>
                    <div style={{ textAlign: "left", marginBottom: "12px" }}>
                      <div
                        style={{
                          textAlign: "left",
                          color: "#909090",
                          marginBottom: "8px",
                          fontSize: "13px",
                        }}
                      >
                        <svg
                          style={{
                            marginRight: "8px",
                          }}
                          width="9"
                          height="10"
                          viewBox="0 0 9 10"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <circle cx="4.5" cy="5" r="4.5" fill="#EAA53D" />
                        </svg>
                        Pending
                      </div>
                      <div style={{ textAlign: "left" }}>
                        {kFormatter2(
                          dashboardData6?.institutionData
                            ?.totalPendingTransactionCount || 0
                        )}
                      </div>
                    </div>
                    <div style={{ textAlign: "left", marginBottom: "12px" }}>
                      <div
                        style={{
                          textAlign: "left",
                          color: "#909090",
                          fontSize: "13px",
                          marginBottom: "8px",
                        }}
                      >
                        <svg
                          style={{
                            marginRight: "8px",
                          }}
                          width="9"
                          height="10"
                          viewBox="0 0 9 10"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <circle cx="4.5" cy="5" r="4.5" fill="#F34235" />
                        </svg>
                        Failed
                      </div>
                      <div style={{ textAlign: "left" }}>
                        {kFormatter2(
                          dashboardData6?.institutionData
                            ?.totalFailedTransactionCount || 0
                        )}
                      </div>
                    </div>
                  </div>
                </Terminal>
              ))}
            {handleCheckMetric(
              "transactionCountAmount",
              userData?.userDetail?.metrics
            ) &&
              (loading ? (
                <Skeleton2 height="100%" />
              ) : (
                <Terminal style={{ background: "#F6ECDF" }}>
                  <svg
                    style={{ position: "absolute", top: "14px", right: "14px" }}
                    width="58"
                    height="57"
                    viewBox="0 0 58 57"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <rect
                      x="5"
                      y="4.5"
                      width="48"
                      height="48"
                      rx="24"
                      fill="#EAA03F"
                    />
                    <path
                      d="M29.5323 18.7538C24.0182 18.6021 19.5007 23.0329 19.5007 28.5038H18.7965C18.309 28.5038 17.8756 28.5038 18.4173 29.4246L20.2048 32.4579C20.4215 32.6746 20.7573 32.6746 20.974 32.4579L22.599 29.4246C22.6738 29.3482 22.7244 29.2514 22.7443 29.1464C22.7643 29.0413 22.7526 28.9327 22.7109 28.8342C22.6692 28.7357 22.5993 28.6518 22.51 28.593C22.4207 28.5342 22.3159 28.5032 22.209 28.5038H21.6673C21.6673 24.2788 25.1123 20.8663 29.359 20.9204C33.389 20.9746 36.7798 24.3654 36.834 28.3954C36.8882 32.6313 33.4757 36.0871 29.2507 36.0871C27.5065 36.0871 25.8923 35.4913 24.614 34.4838C24.4065 34.3203 24.1462 34.2388 23.8825 34.2548C23.6188 34.2708 23.3702 34.3831 23.184 34.5704C22.729 35.0254 22.7615 35.7946 23.2707 36.1846C24.9727 37.5306 27.0807 38.26 29.2507 38.2538C34.7215 38.2538 39.1523 33.7363 39.0007 28.2221C38.8598 23.1413 34.6132 18.8946 29.5323 18.7538ZM28.9798 24.1704C28.5357 24.1704 28.1673 24.5388 28.1673 24.9829V28.9696C28.1673 29.3488 28.3732 29.7063 28.6982 29.9013L32.0782 31.9054C32.4682 32.1329 32.9665 32.0029 33.194 31.6238C33.4215 31.2338 33.2915 30.7354 32.9123 30.5079L29.7923 28.6554V24.9721C29.7923 24.5388 29.424 24.1704 28.9798 24.1704Z"
                      fill="white"
                    />
                    <rect
                      x="5"
                      y="4.5"
                      width="48"
                      height="48"
                      rx="24"
                      stroke="#EAA03F"
                      stroke-opacity="0.1"
                      stroke-width="9"
                    />
                  </svg>

                  <div>
                    <div style={{ color: "#909090" }}>
                      Total Transaction Amount
                    </div>
                    <div style={{ fontSize: "28px", marginTop: "10px" }}>
                      {kFormatter3(
                        dashboardData6?.institutionData
                          ?.totalTransactionAmount || 0
                      )}
                    </div>
                  </div>
                  <div
                    style={{
                      marginTop: "24px",
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "flex-start",
                      alignItems: "flex-start",
                    }}
                  >
                    <div style={{ textAlign: "left", marginBottom: "12px" }}>
                      <div
                        style={{
                          textAlign: "left",
                          color: "#909090",
                          marginBottom: "8px",
                          fontSize: "13px",
                        }}
                      >
                        <svg
                          style={{
                            marginRight: "2px",
                          }}
                          width="9"
                          height="10"
                          viewBox="0 0 9 10"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <circle cx="4.5" cy="5" r="4.5" fill="#01A926" />
                        </svg>
                        Successful
                      </div>
                      <div style={{ textAlign: "left" }}>
                        {kFormatter3(
                          dashboardData6?.institutionData
                            ?.totalSuccessTransactionAmount || 0
                        )}
                      </div>
                    </div>
                    <div style={{ textAlign: "left", marginBottom: "12px" }}>
                      <div
                        style={{
                          textAlign: "left",
                          color: "#909090",
                          marginBottom: "8px",
                          fontSize: "13px",
                        }}
                      >
                        <svg
                          style={{
                            marginRight: "2px",
                          }}
                          width="9"
                          height="10"
                          viewBox="0 0 9 10"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <circle cx="4.5" cy="5" r="4.5" fill="#EAA53D" />
                        </svg>
                        Pending
                      </div>
                      <div style={{ textAlign: "left" }}>
                        {kFormatter3(
                          dashboardData6?.institutionData
                            ?.totalPendingTransactionAmount || 0
                        )}
                      </div>
                    </div>
                    <div style={{ textAlign: "left" }}>
                      <div
                        style={{
                          textAlign: "left",
                          color: "#909090",
                          marginBottom: "8px",
                          fontSize: "13px",
                        }}
                      >
                        <svg
                          style={{
                            marginRight: "2px",
                          }}
                          width="9"
                          height="10"
                          viewBox="0 0 9 10"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <circle cx="4.5" cy="5" r="4.5" fill="#F34235" />
                        </svg>
                        Failed
                      </div>
                      <div style={{ textAlign: "left" }}>
                        {kFormatter3(
                          dashboardData6?.institutionData
                            ?.totalFailedTransactionAmount || 0
                        )}
                      </div>
                    </div>
                  </div>
                </Terminal>
              ))}

            {handleCheckMetric(
              "institutionUserAdminCount",
              userData?.userDetail?.metrics
            ) &&
              (loading ? (
                <Skeleton2 height="100%" />
              ) : (
                <Terminal style={{ background: "#DFDFF6" }}>
                  <svg
                    style={{ position: "absolute", top: "14px", right: "14px" }}
                    width="58"
                    height="57"
                    viewBox="0 0 58 57"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <rect
                      x="5"
                      y="4.5"
                      width="48"
                      height="48"
                      rx="24"
                      fill="#6A6AEA"
                    />
                    <path
                      d="M33.0951 22.9359C33.0951 25.7105 31.2617 27.9598 29.0001 27.9598C26.7385 27.9598 24.9051 25.7105 24.9051 22.9359C24.9051 20.1614 26.7385 17.9121 29.0001 17.9121C31.2617 17.9121 33.0951 20.1614 33.0951 22.9359Z"
                      fill="white"
                    />
                    <path
                      d="M37.1901 35.4955C37.1901 38.5476 33.0207 37.5051 29.0001 37.5051C24.9794 37.5051 20.8101 38.5476 20.8101 35.4955C20.8101 32.4435 24.9794 29.9693 29.0001 29.9693C33.0207 29.9693 37.1901 32.4435 37.1901 35.4955Z"
                      fill="white"
                    />
                    <path
                      d="M31.9881 30.1659L31.9881 30.1659L30.8371 29.7544C30.3836 30.2563 30.0402 30.8484 29.8318 31.493L30.7647 32.2851L30.7647 32.2851C30.8019 32.3167 30.8365 32.3513 30.8682 32.3886C31.1899 32.7675 31.1436 33.3354 30.7647 33.6571L30.7647 33.6571L29.8318 34.4492C30.0402 35.0938 30.3836 35.6859 30.8371 36.1878L31.9881 35.7762L31.9882 35.7762C32.0342 35.7598 32.0815 35.7471 32.1295 35.7384L32.1824 36.0284L32.1295 35.7384C32.6185 35.6492 33.0872 35.9733 33.1764 36.4623L33.1764 36.4623L33.3957 37.6659C33.7232 37.7356 34.0591 37.7711 34.3999 37.7711C34.7404 37.7711 35.0762 37.7356 35.4035 37.666L35.6233 36.4624L35.6233 36.4623L35.9184 36.5162C35.9243 36.4841 35.9328 36.4525 35.9437 36.4218C36.0552 36.1098 36.3986 35.9472 36.7106 36.0587L31.9881 30.1659ZM31.9881 30.1659C32.4562 30.3332 32.9712 30.0894 33.1385 29.6213L32.856 29.5203M31.9881 30.1659L32.856 29.5203M32.856 29.5203L33.1385 29.6213C33.155 29.5753 33.1676 29.528 33.1764 29.48L33.1764 29.4799M32.856 29.5203L33.1764 29.4799M33.1764 29.4799L33.3957 28.2763C33.7232 28.2066 34.0591 28.1711 34.3999 28.1711C34.7404 28.1711 35.0762 28.2065 35.4035 28.2762L35.6233 29.4799L33.1764 29.4799ZM32.8999 32.9711C32.8999 33.7995 33.5714 34.4711 34.3999 34.4711C35.2283 34.4711 35.8999 33.7995 35.8999 32.9711C35.8999 32.1427 35.2283 31.4711 34.3999 31.4711C33.5714 31.4711 32.8999 32.1427 32.8999 32.9711Z"
                      fill="white"
                      stroke="#6A6AEA"
                      stroke-width="0.6"
                    />
                    <rect
                      x="5"
                      y="4.5"
                      width="48"
                      height="48"
                      rx="24"
                      stroke="#6A6AEA"
                      stroke-opacity="0.1"
                      stroke-width="9"
                    />
                  </svg>

                  <div>
                    <div style={{ color: "#909090" }}>
                      Total Institution Admins
                    </div>
                    <div style={{ fontSize: "28px", marginTop: "10px" }}>
                      {kFormatter2(
                        dashboardData5?.institutionData?.institutionAdmin || 0
                      )}
                    </div>
                  </div>
                  <div
                    style={{
                      marginTop: "24px",
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "flex-start",
                      alignItems: "flex-start",
                    }}
                  ></div>
                </Terminal>
              ))}

            {handleCheckMetric(
              "institutionUserAdminCount",
              userData?.userDetail?.metrics
            ) &&
              (loading ? (
                <Skeleton2 height="100%" />
              ) : (
                <Terminal style={{ background: "#F2DFF6" }}>
                  <svg
                    style={{ position: "absolute", top: "14px", right: "14px" }}
                    width="58"
                    height="57"
                    viewBox="0 0 58 57"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <rect
                      x="5"
                      y="4.5"
                      width="48"
                      height="48"
                      rx="24"
                      fill="#D04AED"
                    />
                    <path
                      d="M41.1178 24.0753C41.1178 26.6021 39.3796 28.6506 37.2354 28.6506C35.0912 28.6506 33.3531 26.6021 33.3531 24.0753C33.3531 21.5484 35.0912 19.5 37.2354 19.5C39.3796 19.5 41.1178 21.5484 41.1178 24.0753Z"
                      fill="white"
                    />
                    <path
                      d="M45.0001 35.5135C45.0001 38.293 41.0473 37.3436 37.2354 37.3436C33.4236 37.3436 29.4707 38.293 29.4707 35.5135C29.4707 32.7339 33.4236 30.4807 37.2354 30.4807C41.0473 30.4807 45.0001 32.7339 45.0001 35.5135Z"
                      fill="white"
                    />
                    <path
                      d="M24.4117 24.0753C24.4117 26.6021 22.6735 28.6506 20.5294 28.6506C18.3852 28.6506 16.647 26.6021 16.647 24.0753C16.647 21.5484 18.3852 19.5 20.5294 19.5C22.6735 19.5 24.4117 21.5484 24.4117 24.0753Z"
                      fill="white"
                    />
                    <path
                      d="M28.2941 35.5135C28.2941 38.293 24.3412 37.3436 20.5294 37.3436C16.7175 37.3436 12.7646 38.293 12.7646 35.5135C12.7646 32.7339 16.7175 30.4807 20.5294 30.4807C24.3412 30.4807 28.2941 32.7339 28.2941 35.5135Z"
                      fill="white"
                    />
                    <path
                      d="M33.3412 23.8378C33.3412 26.7858 31.3502 29.1757 28.8941 29.1757C26.4381 29.1757 24.4471 26.7858 24.4471 23.8378C24.4471 20.8898 26.4381 18.5 28.8941 18.5C31.3502 18.5 33.3412 20.8898 33.3412 23.8378Z"
                      fill="white"
                    />
                    <path
                      d="M37.7882 37.1824C37.7882 40.4252 33.2604 39.3175 28.8941 39.3175C24.5278 39.3175 20 40.4252 20 37.1824C20 33.9396 24.5278 31.3108 28.8941 31.3108C33.2604 31.3108 37.7882 33.9396 37.7882 37.1824Z"
                      fill="white"
                    />
                    <path
                      d="M33.3412 23.8378C33.3412 26.7858 31.3502 29.1757 28.8941 29.1757C26.4381 29.1757 24.4471 26.7858 24.4471 23.8378C24.4471 20.8898 26.4381 18.5 28.8941 18.5C31.3502 18.5 33.3412 20.8898 33.3412 23.8378Z"
                      stroke="#D04AED"
                    />
                    <path
                      d="M37.7882 37.1824C37.7882 40.4252 33.2604 39.3175 28.8941 39.3175C24.5278 39.3175 20 40.4252 20 37.1824C20 33.9396 24.5278 31.3108 28.8941 31.3108C33.2604 31.3108 37.7882 33.9396 37.7882 37.1824Z"
                      stroke="#D04AED"
                    />
                    <rect
                      x="5"
                      y="4.5"
                      width="48"
                      height="48"
                      rx="24"
                      stroke="#D04AED"
                      stroke-opacity="0.1"
                      stroke-width="9"
                    />
                  </svg>

                  <div>
                    <div style={{ color: "#909090" }}>
                      Total Institution Users
                    </div>
                    <div style={{ fontSize: "28px", marginTop: "10px" }}>
                      {kFormatter2(
                        dashboardData5?.institutionData?.institutionAdmin || 0
                      )}
                    </div>
                  </div>
                  <div
                    style={{
                      marginTop: "24px",
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "flex-start",
                      alignItems: "flex-start",
                    }}
                  >
                    <div style={{ textAlign: "left", marginBottom: "12px" }}>
                      <div
                        style={{
                          textAlign: "left",
                          color: "#909090",
                          marginBottom: "8px",
                          fontSize: "13px",
                        }}
                      >
                        User 1
                      </div>
                      <div style={{ textAlign: "left" }}>
                        {kFormatter4(
                          dashboardData5?.institutionData
                            ?.institutionFirstUser || 0
                        )}
                      </div>
                    </div>
                    <div style={{ textAlign: "left", marginBottom: "12px" }}>
                      <div
                        style={{
                          textAlign: "left",
                          color: "#909090",
                          marginBottom: "8px",
                          fontSize: "13px",
                        }}
                      >
                        User 2
                      </div>
                      <div style={{ textAlign: "left" }}>
                        {kFormatter4(
                          dashboardData5?.institutionData
                            ?.institutionSecondUser || 0
                        )}
                      </div>
                    </div>
                  </div>
                </Terminal>
              ))}
          </Gridtemplate>

          {handleCheckMetric(
            "todayTransaction",
            userData?.userDetail?.metrics
          ) &&
            (loading ? (
              <Skeleton2 height="400px" />
            ) : (
              <TransactionReport>
                <div
                  style={{
                    padding: "0px 30px",
                    paddingTop: "30px",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                    }}
                  >
                    Today's Transactions
                    {boundType === "inbound" && (
                      <svg
                        width="25"
                        height="24"
                        viewBox="0 0 25 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <circle cx="12.2554" cy="12" r="12" fill="#BDBDBD" />
                        <rect
                          x="10.2554"
                          y="9.3335"
                          width="4.17391"
                          height="10.6666"
                          rx="2.08695"
                          fill="white"
                        />
                        <rect
                          x="10.2554"
                          y="4"
                          width="4.17391"
                          height="3.99999"
                          rx="2"
                          fill="white"
                        />
                      </svg>
                    )}
                    {boundType === "outbound" && (
                      <div
                        style={{
                          margin: "10px 0",
                          cursor: "pointer",
                          border: "1px solid #d4d4d4",
                          padding: "6px",
                          borderRadius: "4px",
                          width: "fit-content",
                          position: "relative",
                          fontSize: "11px",
                        }}
                        onClick={(e) => {
                          setShowBanks(!showBanks);
                          setShowResponseTimeBanks(false);
                          e.stopPropagation();
                        }}
                      >
                        {checked2}{" "}
                        <svg
                          style={{ width: "7px" }}
                          width="10"
                          height="6"
                          viewBox="0 0 10 6"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M1.25 1.125L5 4.875L8.75 1.125"
                            stroke="#5A6376"
                            stroke-width="1.875"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                        </svg>
                        {showBanks && (
                          <RadioFilter
                            onClick={(e) => {
                              e.stopPropagation();
                            }}
                            setChecked2={setChecked2}
                            loading={loading}
                            banks={banks}
                            setChecked={setChecked}
                            checked={checked}
                            onClick2={() => {
                              setShowBanks(false);
                            }}
                          />
                        )}
                      </div>
                    )}
                  </div>
                  <h2
                    style={{
                      borderBottom: "1px solid #F0F0F0",
                      padding: "0px 0px",
                      paddingBottom: "20px",
                      fontWeight: "500",
                    }}
                  >
                    {kFormatter3(
                      dashboardData6?.institutionData?.totalTransactionAmount ||
                      0
                    )}
                  </h2>
                </div>

                <TodayTransactionsChart
                  countAmount={kFormatter2(
                    dashboardData6?.institutionData?.totalTransactionCount || 0
                  )}
                  options={options3}
                  data={[
                    {
                      pendingAmount:
                        dashboardData6?.institutionData
                          ?.totalPendingTransactionAmount || 0,
                      pendingCount:
                        dashboardData6?.institutionData
                          ?.totalPendingTransactionCount || 0,
                    },
                    {
                      successfulAmount:
                        dashboardData6?.institutionData
                          ?.totalSuccessTransactionAmount || 0,
                      successfulCount:
                        dashboardData6?.institutionData
                          ?.totalSuccessTransactionCount || 0,
                    },
                    {
                      failedAmount:
                        dashboardData6?.institutionData
                          ?.totalFailedTransactionAmount || 0,
                      failedCount:
                        dashboardData6?.institutionData
                          ?.totalFailedTransactionCount || 0,
                    },
                  ]}
                />
              </TransactionReport>
            ))}
        </Chatgrid>

        <div>
          {balanceEnquiry && (
            <Terminal style={{ background: "#DFDFF6" }}>
              <div style={{ width: "100%" }}>
                {/* Header */}
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "12px",
                    marginBottom: "24px",
                    paddingBottom: "16px",
                    borderBottom: "1px solid #E0E0E0",
                  }}
                >
                  <div
                    style={{
                      width: "48px",
                      height: "48px",
                      borderRadius: "12px",
                      background:
                        "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <svg
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M12 2L13.09 8.26L20 9L13.09 9.74L12 16L10.91 9.74L4 9L10.91 8.26L12 2Z"
                        fill="white"
                      />
                    </svg>
                  </div>
                  <div>
                    <h3
                      style={{
                        margin: 0,
                        fontSize: "24px",
                        fontWeight: "600",
                        color: "#333",
                      }}
                    >
                      Balance Enquiry
                    </h3>
                    <p
                      style={{
                        margin: "4px 0 0 0",
                        fontSize: "14px",
                        color: "#666",
                      }}
                    >
                      Account balance and status information
                    </p>
                  </div>
                </div>

                {/* Main Content Grid */}
                <div
                  style={{
                    display: "grid",
                    gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))",
                    gap: "24px",
                  }}
                >
                  {/* Account Information Section */}

                  {/* Balance Information Section */}
                  <div
                    style={{
                      background: "white",
                      borderRadius: "12px",
                      padding: "20px",
                      border: "1px solid #E8E8E8",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "8px",
                        marginBottom: "16px",
                      }}
                    >
                      <svg
                        width="16"
                        height="16"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M11.8 10.9c-2.27-.59-3-1.2-3-2.15 0-1.09 1.01-1.85 2.7-1.85 1.78 0 2.44.85 2.5 2.1h2.21c-.07-1.72-1.12-3.3-3.21-3.81V3h-3v2.16c-1.94.42-3.5 1.68-3.5 3.61 0 2.31 1.91 3.46 4.7 4.13 2.5.6 3 1.48 3 2.41 0 .69-.49 1.79-2.7 1.79-2.06 0-2.87-.92-2.98-2.1h-2.2c.12 2.19 1.76 3.42 3.68 3.83V21h3v-2.15c1.95-.37 3.5-1.5 3.5-3.55 0-2.84-2.43-3.81-4.7-4.4z"
                          fill="#2196F3"
                        />
                      </svg>
                      <h4
                        style={{
                          margin: 0,
                          fontSize: "16px",
                          fontWeight: "600",
                          color: "#333",
                        }}
                      >
                        Balance & Credits
                      </h4>
                    </div>

                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        gap: "12px",
                      }}
                    >
                      <div
                        style={{
                          background:
                            "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                          borderRadius: "8px",
                          padding: "16px",
                          color: "white",
                          display: 'grid',
                          gridTemplateColumns: '1fr 1fr'
                        }}
                      >
                        <div>
                          <div
                            style={{
                              fontSize: "14px",
                              opacity: 0.9,
                              marginBottom: "4px",
                            }}
                          >
                            Current Balance
                          </div>
                          <div style={{ fontSize: "24px", fontWeight: "700" }}>
                            {balanceEnquiry?.current_balance
                              ? `₦${parseFloat(
                                balanceEnquiry.current_balance
                              ).toLocaleString()}`
                              : balanceEnquiry.current_balance === null ? 0 : balanceEnquiry.current_balance}
                          </div>
                        </div>
                        <div>
                          <div
                            style={{
                              fontSize: "14px",
                              opacity: 0.9,
                              marginBottom: "4px",
                            }}
                          >
                            Account Number
                          </div>
                          <div style={{ fontSize: "24px", fontWeight: "700" }}>
                            {balanceEnquiry?.account_number
                              ? balanceEnquiry.account_number
                              : balanceEnquiry.account_number === null ? 0 : balanceEnquiry.account_number || 0}
                          </div>
                        </div>
                      </div>

                      <button
                        onClick={() => route(`/institution-credit-history?id=${id}&code=${code}`)}
                        style={{
                          alignSelf: "flex-start",
                          background: "#14a2fd",
                          color: "white",
                          border: "none",
                          borderRadius: "6px",
                          padding: "10px 20px",
                          fontSize: "16px",
                          fontWeight: "600",
                          cursor: "pointer",
                          transition: "background 0.2s",
                          width: "max-content",
                        }}
                        onMouseOver={(e) => (e.currentTarget.style.background = "#0f8adb")}
                        onMouseOut={(e) => (e.currentTarget.style.background = "#14a2fd")}
                      >
                        Credit History
                      </button>
                    </div>
                  </div>

                  {/* Response Information Section */}
                </div>

                {/* Loading State */}
                {loadingEnquiry && (
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      padding: "40px",
                      color: "#666",
                    }}
                  >
                    <div
                      style={{
                        width: "20px",
                        height: "20px",
                        border: "2px solid #E0E0E0",
                        borderTop: "2px solid #14A2FD",
                        borderRadius: "50%",
                        animation: "spin 1s linear infinite",
                        marginRight: "12px",
                      }}
                    />
                    Loading balance enquiry data...
                  </div>
                )}
              </div>
            </Terminal>
          )}
          <br />
        </div>
        {handleCheckMetric(
          "transactionCountAmount",
          userData?.userDetail?.metrics
        ) &&
          (loading ? (
            <Skeleton2 height="400px" />
          ) : (
            <Chatgrid2>
              <Total>
                <div className="limit">
                  <div className="total_transaction">
                    <p style={{ fontSize: "13px" }}>Total Transaction Amount</p>
                  </div>

                  <div
                    style={{
                      display: "flex",
                      gap: "10px",
                      alignItems: "center",
                    }}
                  >
                    <div className="duration">
                      <span
                        style={{
                          cursor: "pointer",
                          borderBottom: "2px solid #78d7ff",
                        }}
                      >
                        Weekly
                      </span>
                    </div>
                  </div>
                </div>
                <TotalTransactionChart
                  dataInner={"week"}
                  data={totaltTransactions?.weekly}
                  color="#FCAC61"
                  mainKey="amount"
                />
              </Total>

              <Total>
                <div className="limit">
                  <div className="total_transaction">
                    <p style={{ fontSize: "13px" }}>Total Transaction Count</p>
                  </div>

                  <div
                    style={{
                      display: "flex",
                      gap: "10px",
                      alignItems: "center",
                    }}
                  >
                    <div className="duration">
                      <span
                        style={{
                          cursor: "pointer",
                          borderBottom: "2px solid #78d7ff",
                        }}
                      >
                        Weekly
                      </span>
                    </div>
                  </div>
                </div>
                <TotalTransactionChart
                  dataInner={"week"}
                  data={totaltTransactions?.weekly}
                  color="#00B3FE"
                  mainKey="count"
                />
              </Total>
            </Chatgrid2>
          ))}
        {handleCheckMetric(
          "transactionPerformance",
          userData?.userDetail?.metrics
        ) &&
          (loading ? (
            <Skeleton2 height="400px" />
          ) : (
            <TransactionPerformanc>
              <FlexPerformance>
                <div className="performance">
                  <span>Statistics</span>
                  <p>Transaction Performance</p>
                </div>
                <div className="btn">
                  <div className="outwardTransaction">
                    <VscCircleFilled style={{ color: "#01A926" }} size={15} />
                    Successful Transaction
                  </div>
                  <div className="outwardTransaction">
                    <VscCircleFilled style={{ color: "#FF993A" }} size={15} />
                    Pending Transaction
                  </div>
                  <div className="outwardTransaction">
                    <VscCircleFilled style={{ color: "#FF0000" }} size={15} />
                    Failed Transaction
                  </div>
                </div>
              </FlexPerformance>
              <TransactionPerformance options={options2} />
            </TransactionPerformanc>
          ))}
        <Table>
          <TableHead>
            <div className="table_head">
              <div>
                <div className="title_b">Recent Transactions</div>
              </div>
              <div className="table_head_inner"></div>
            </div>
          </TableHead>
          <TableBody>
            <TableBodyContent className="table_body_head grid_attribute">
              <div style={{ width: "100px", marginRight: "10px" }}>
                Source bank
              </div>
              <div style={{ width: "100px", marginRight: "10px" }}>
                Dest bank
              </div>
              <div style={{ width: "100px", marginRight: "10px" }}>
                Account No.
              </div>
              <div style={{ width: "120px", marginRight: "10px" }}>Amount</div>
              <div
                style={{
                  width: "250px",
                  marginRight: "10px",
                }}
              >
                Remark
              </div>
              <div style={{ width: "250px", marginRight: "10px" }}>
                status message
              </div>
              <div style={{ width: "100px", marginRight: "10px" }}>
                status code
              </div>
              <div style={{ width: "250px", marginRight: "10px" }}>
                beneficiary
              </div>
              <div style={{ width: "110px", marginRight: "10px" }}>sender</div>
              <div style={{ width: "100px", marginRight: "10px" }}>
                debit account
              </div>
              <div style={{ width: "60px", marginRight: "10px" }}>approved</div>
              <div style={{ width: "100px", marginRight: "10px" }}>
                request type
              </div>
              <div style={{ width: "120px", marginRight: "10px" }}>
                reference
              </div>

              <div style={{ width: "100px", marginRight: "10px" }}>
                request id
              </div>
              <div style={{ width: "160px", marginRight: "10px" }}>
                request time
              </div>

              <div style={{ width: "160px", marginRight: "10px" }}>
                response time
              </div>
              <div style={{ width: "80px", marginRight: "10px" }}>
                response id
              </div>
              <div style={{ width: "180px", marginRight: "10px" }}>rrn</div>
              <div style={{ width: "100px", marginRight: "10px" }}>
                requery count
              </div>

              <div style={{ width: "100px", marginRight: "10px" }}>
                batch id
              </div>
            </TableBodyContent>

            <div>
              {" "}
              {loading ? (
                <Skeleton2 height="300px" />
              ) : (
                <TableBodyContent>
                  {transactions?.map((item) => {
                    return (
                      <div className="table_body_item grid_attribute">
                        <div
                          style={{
                            wordBreak: "break-word",
                            marginRight: "10px",
                            width: "100px",
                          }}
                        >
                          {item?.sourcebank || "-"}
                        </div>
                        <div
                          style={{
                            wordBreak: "break-word",
                            marginRight: "10px",
                            width: "100px",
                          }}
                        >
                          {item?.destbank || "-"}
                        </div>
                        <div
                          style={{
                            wordBreak: "break-word",
                            marginRight: "10px",
                            width: "100px",
                          }}
                        >
                          {item?.accountno || "-"}
                        </div>
                        <div
                          style={{
                            wordBreak: "break-word",
                            marginRight: "10px",
                            width: "120px",
                          }}
                        >
                          {kFormatter3(item?.amount)}
                        </div>
                        <div
                          style={{
                            wordBreak: "break-word",
                            marginRight: "10px",
                            width: "250px",
                          }}
                        >
                          {item?.remark || "-"}
                        </div>
                        <div
                          style={{
                            wordBreak: "break-word",
                            marginRight: "10px",
                            width: "250px",
                          }}
                        >
                          {item?.statusmessage || "-"}
                        </div>
                        <div
                          style={{
                            wordBreak: "break-word",
                            marginRight: "10px",
                            width: "100px",
                          }}
                        >
                          {item?.statuscode || "-"}
                        </div>
                        <div
                          style={{
                            wordBreak: "break-word",
                            marginRight: "10px",
                            width: "250px",
                          }}
                        >
                          {item?.beneficiary ? `${item?.beneficiary}` : "N/A"}
                        </div>
                        <div
                          style={{
                            wordBreak: "break-word",
                            marginRight: "10px",
                            width: "110px",
                          }}
                        >
                          {item?.sender || "-"}
                        </div>
                        <div
                          style={{
                            wordBreak: "break-word",
                            marginRight: "10px",
                            width: "100px",
                          }}
                        >
                          {item?.debitaccount || "N/A"}
                        </div>
                        <div
                          style={{
                            wordBreak: "break-word",
                            marginRight: "10px",
                            width: "60px",
                          }}
                        >
                          {(item?.approved && "True") || "-"}
                        </div>
                        <div
                          style={{
                            wordBreak: "break-word",
                            marginRight: "10px",
                            width: "100px",
                          }}
                        >
                          {item?.requesttype || "-"}
                        </div>
                        <div
                          style={{
                            wordBreak: "break-word",
                            marginRight: "10px",
                            width: "120px",
                          }}
                        >
                          {item?.reference || "N/A"}
                        </div>

                        <div
                          style={{
                            wordBreak: "break-word",
                            marginRight: "10px",
                            width: "100px",
                          }}
                        >
                          {item?.requestid || "-"}
                        </div>
                        <div
                          style={{
                            wordBreak: "break-word",
                            marginRight: "10px",
                            width: "160px",
                          }}
                        >
                          {moment(item?.requesttime)
                            .subtract(1, "hours")
                            .format("DD-MM-YYYY hh:mm")}
                        </div>

                        <div
                          style={{
                            wordBreak: "break-word",
                            marginRight: "10px",
                            width: "160px",
                          }}
                        >
                          {moment(item?.responsetime)
                            .subtract(1, "hours")
                            .format("DD-MM-YYYY hh:mm")}
                        </div>
                        <div
                          style={{
                            wordBreak: "break-word",
                            marginRight: "10px",
                            width: "80px",
                          }}
                        >
                          {item?.responseid || "N/A"}
                        </div>

                        <div
                          style={{
                            wordBreak: "break-word",
                            marginRight: "10px",
                            width: "180px",
                          }}
                        >
                          {item?.rrn || "N/A"}
                        </div>
                        <div
                          style={{
                            wordBreak: "break-word",
                            marginRight: "10px",
                            width: "100px",
                          }}
                        >
                          {item?.requerycount || "-"}
                        </div>

                        <div
                          style={{
                            wordBreak: "break-word",
                            marginRight: "10px",
                            width: "100px",
                          }}
                        >
                          {item?.batchid || "N/A"}
                        </div>
                      </div>
                    );
                  })}
                </TableBodyContent>
              )}
            </div>
          </TableBody>
          <div
            style={{
              padding: "20px",
              width: "fit-content",
              marginLeft: "auto",
            }}
          >
            <div
              style={{
                display: "flex",
                alignItems: "center",
                color: "#14A2FD",
                cursor: "pointer",
                textDecoration: "underline",
              }}
              onClick={() => {
                if (
                  userData?.userDetail?.role === "chiefAdmin" ||
                  userData?.userDetail?.role === "subAdmin1" ||
                  userData?.userDetail?.role === "subAdmin2"
                ) {
                  showTransactions(true);
                  close(false);
                } else {
                  route("/transactions");
                }
              }}
            >
              View All Transactions{" "}
              <svg
                width="21"
                height="21"
                viewBox="0 0 21 21"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g clip-path="url(#clip0_127_5725)">
                  <path
                    d="M8.15674 6.19941L11.9734 10.0244L8.15674 13.8494L9.33174 15.0244L14.3317 10.0244L9.33174 5.02441L8.15674 6.19941Z"
                    fill="#14A2FD"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_127_5725">
                    <rect
                      width="20"
                      height="20"
                      fill="white"
                      transform="translate(0.998535 20.0244) rotate(-90)"
                    />
                  </clipPath>
                </defs>
              </svg>
            </div>
          </div>
        </Table>
      </>

      {/* Balance Configuration Modal */}
      {balanceConfigModal && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 1000,
          }}
          onClick={() => setBalanceConfigModal(false)}
        >
          <div
            style={{
              backgroundColor: "white",
              borderRadius: "20px",
              padding: "30px",
              width: "500px",
              maxWidth: "90vw",
              maxHeight: "90vh",
              overflow: "auto",
            }}
            onClick={(e) => e.stopPropagation()}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                marginBottom: "20px",
              }}
            >
              <h2 style={{ margin: 0, color: "#333" }}>
                {editingConfigIndex !== null && Array.isArray(balanceConfig)
                  ? `Configure ${balanceConfig[editingConfigIndex]?.organisation?.name ||
                  "Institution"
                  }`
                  : "Balance Configuration"}
              </h2>
              <button
                onClick={() => {
                  setBalanceConfigModal(false);
                  setEditingConfigIndex(null);
                }}
                style={{
                  background: "none",
                  border: "none",
                  fontSize: "24px",
                  cursor: "pointer",
                  color: "#666",
                }}
              >
                ×
              </button>
            </div>

            <div style={{ marginBottom: "20px" }}>
              <FormInput
                label="Account Number *"
                placeholder="Enter account number"
                value={balanceConfigData.accountNumber}
                onChange={(e) =>
                  setBalanceConfigData({
                    ...balanceConfigData,
                    accountNumber: e.target.value,
                  })
                }
              />
            </div>

            <div style={{ marginBottom: "20px" }}>
              <FormInput
                label="Balance API URL *"
                placeholder="https://api.example.com/balance-enquiry"
                value={balanceConfigData.balanceApiUrl}
                onChange={(e) =>
                  setBalanceConfigData({
                    ...balanceConfigData,
                    balanceApiUrl: e.target.value,
                  })
                }
              />
            </div>

            <div style={{ marginBottom: "20px" }}>
              <label
                style={{ display: "block", marginBottom: "8px", color: "#333" }}
              >
                Balance API Enabled
              </label>
              <div
                style={{ display: "flex", alignItems: "center", gap: "10px" }}
              >
                <input
                  type="checkbox"
                  checked={balanceConfigData.balanceApiEnabled}
                  onChange={(e) =>
                    setBalanceConfigData({
                      ...balanceConfigData,
                      balanceApiEnabled: e.target.checked,
                    })
                  }
                  style={{ width: "18px", height: "18px" }}
                />
                <span style={{ color: "#666" }}>
                  Enable balance enquiry API
                </span>
              </div>
            </div>

            <div
              style={{
                display: "flex",
                gap: "15px",
                justifyContent: "flex-end",
                marginTop: "30px",
              }}
            >
              <button
                onClick={() => setBalanceConfigModal(false)}
                style={{
                  padding: "12px 24px",
                  border: "1px solid #ddd",
                  borderRadius: "8px",
                  background: "white",
                  cursor: "pointer",
                  color: "#666",
                }}
              >
                Cancel
              </button>
              <button
                onClick={handleBalanceConfigSubmit}
                disabled={loadingBalance}
                style={{
                  padding: "12px 24px",
                  border: "none",
                  borderRadius: "8px",
                  background: loadingBalance ? "#ccc" : "#14A2FD",
                  cursor: loadingBalance ? "not-allowed" : "pointer",
                  color: "white",
                  display: "flex",
                  alignItems: "center",
                  gap: "8px",
                }}
              >
                {loadingBalance ? (
                  <>
                    <div
                      style={{
                        width: "16px",
                        height: "16px",
                        border: "2px solid #fff",
                        borderTop: "2px solid transparent",
                        borderRadius: "50%",
                        animation: "spin 1s linear infinite",
                      }}
                    />
                    Configuring...
                  </>
                ) : (
                  "Configure Balance"
                )}
              </button>
            </div>
          </div>
        </div>
      )}
    </Bg>
  );
}

export default InstitutionDetails;
const GaugeStyle = styled.div`
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  width: 100%;
`;
const TransactionPerformanc = styled.div`
  padding: 12px;
  border-radius: 20px;
  background-color: white;
  margin: 20px 0;
  cursor: pointer;
`;

const FlexPerformance = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px;
  border-bottom: 1px solid gainsboro;
  .outwardTransaction {
    padding: 7px 10px 7px 10px;
    border-radius: 5px;
    font-size: 11px;
    display: flex;
    align-items: center;
    gap: 5px;
    border: 1px solid #e5e5ef;
  }

  span {
    color: gray;
  }
  .btn {
    display: flex;
    gap: 20px;
  }
  .btn button {
    padding: 5px;
    border: none;
    background-color: transparent;
    border-radius: 5px;
  }
  .gradient {
    background-color: #eff7fa;
    display: flex;
    align-items: center;
    gap: 20px;
    padding-left: 5px;
    border-radius: 5px;
  }
  .gradient select {
    background-color: #eff7fa;
    color: #333333;
    outline: none;
    padding: 5px;
    border: none;
    border-radius: 5px;
  }
  .gradient span {
    font-size: 12px;
  }
`;

const Total = styled.div`
  background-color: white;
  margin-top: 20px;
  padding: 20px;
  border-radius: 20px;
  .limit {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .total_transaction {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 40px;
    padding-left: 30px;
    h3 {
      font-size: 14px;
      font-weight: 500;
    }
    p {
      color: black;
      font-size: 15px;
    }
  }
  .duration {
    display: flex;
    gap: 20px;
    padding: 10px;
    span {
      font-size: 14px;
    }
  }
`;
const Gridtemplate = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-template-rows: repeat(2, 1fr);
  margin-bottom: 20px;
  height: 100%;
  gap: 20px;
`;
const Terminal = styled.div`
  position: relative;
  background-color: white;
  border-radius: 10px;
  padding: 26px;

  .other {
    padding: 10px;
  }
  .TransactImage {
  }
`;
const Bg = styled.div`
  .btn {
    display: flex;
    gap: 20px;
    margin-bottom: 20px;
    margin-top: 0px;
  }
  .btn button {
    padding: 10px 54px;
    border: none;
    background-color: transparent;
    border-radius: 5px;
  }
  .gauge_sec {
    color: #909090;
    font-size: 15px;
  }
  .institution {
    margin-top: 30px;

    h2 {
      color: #464646;
      font-size: 30px;
    }
    p {
      font-weight: 500;
      margin-bottom: 0px;
    }
  }
  .time {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    span {
      font-size: 14px;
      display: flex;
      gap: 10px;
    }
  }
  .header {
    display: flex;
    justify-content: space-between;
  }
  .gauge {
    display: flex;
    position: relative;
    width: fit-content;
    text-align: center;
    position: relative;
    .gauge_text {
      color: #000000;
      font-size: 15px;
      font-weight: 500;
    }
    .gauge_sec {
      color: #000;
      position: absolute;
      top: 60%;
      left: 50%;
      transform: translate(-50%, -90%);
      z-index: 100;
      font-size: 16px;
      padding: 2px;
      background-color: #f5fcff;
    }
  }

  p {
    display: flex;
    gap: 10px;
    color: #04a3e5;
    font-size: 17px;
    cursor: pointer;
  }
`;
//eslint-disable-next-line
const Container = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  .msg {
    display: flex;
    align-items: center;
    gap: 20px;
    height: 50%;
  }
  .notification {
    height: 20%;
  }
  .msg p {
    display: flex;
    align-items: center;
    gap: 10px;
    color: #63666a;
  }
  .search {
    width: 10px;
  }
`;
const Table = styled.div`
  background-color: white;
  border-radius: 10px;
`;

const TableHead = styled.div`
  padding: 0 30px;

  .table_tab {
    display: flex;
    align-items: center;
    margin: 20px 0;
  }

  .table_head {
    padding: 30px 0;
    width: 100%;

    .table_head_inner {
      width: 100%;
      display: flex;
      align-items: center;
      margin-left: 20px;
      justify-content: space-between;
    }
  }

  .title_a {
    font-size: 18px;
    color: #9291a5;
  }

  .title_b {
    font-size: 26px;
    font-weight: 600;
    margin-top: 10px;
  }
`;

const TableBody = styled.div`
  overflow: hidden;
  overflow-x: scroll;

  &::-webkit-scrollbar {
    width: 10px;
    height: 6px;
    padding: 10px;
  }
  &::-webkit-scrollbar-thumb {
    width: 10px;
    background-color: #019edf;
    border-radius: 30px;
  }
  .table_body_head {
    padding: 20px 30px;
    text-transform: uppercase;
    background: #fafafa;
    color: #14a2fd;
  }
  .grid_attribute {
    display: grid;
    grid-template-columns: repeat(21, 1fr);
    width: fit-content;
  }
`;

const TableBodyContent = styled.div`
  padding: 10px 0px;
  text-transform: uppercase;
  font-size: 12px;

  .grid_attribute {
    display: grid;
    grid-template-columns: repeat(29, 1fr);
    width: fit-content;
  }

  .table_body_item {
    padding: 20px 30px;
  }

  .table_body_item:nth-child(even) {
    background: #fafafa;
  }
`;
const Chatgrid = styled.div`
  display: grid;
  grid-template-columns: 3fr 1fr;
  width: 100%;
  gap: 20px;
  margin-top: 20px;
  margin-bottom: 20px;
`;
const Chatgrid2 = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  width: 100%;
  gap: 20px;
  margin-bottom: 20px;
`;
const TransactionReport = styled.div`
  border-radius: 20px;
  background-color: white;
  height: 100%;
  border: 1px solid #d2d2d2;

  .inner {
    padding: 22px;
  }
`;
const DropDown = styled.div`
  position: absolute;
  border: 1px solid #bbbbbb;
  border-radius: 20px;
  top: 180%;
  right: 0;
  background-color: white;
  z-index: 100;
  padding: 0 20px;
  padding-top: 8px;
  width: 220%;
  text-transform: capitalize;
  font-size: 14px;
  z-index: 300;
  .title {
    border-bottom: 1px solid #e9e9e9;
    width: 100%;
    font-size: 14px;
    margin-bottom: 20px;
  }
`;

// Add CSS for loading animation
const style = document.createElement("style");
style.textContent = `
  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }
`;
document.head.appendChild(style);
